import { PlexUserRelationState } from '@all-hands-hq/plex-graphql-schema';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import classNames from 'classnames';
import React from 'react';

import { PlexSnackbarFragment } from '../../../../graphql/gen/types';
import { spacings } from '../../../../theme';
import { ButtonColor, PlexButton } from '../../../shared/primitives/PlexButton';
import { canLeave, canSubscribe } from '../../permissions';
import { useSubscribeToPlex } from '../../plexes/useSnackbarSubscribe';

interface Props {
  plex: PlexSnackbarFragment;
}

export const SubscribeButton = React.memo(function SubscribeButton({ plex }: Props): React.ReactElement | null {
  const classes = useStyles();
  const { subscribeLoading, leaveLoading, onSubscribeClick, onLeaveClick } = useSubscribeToPlex();
  const handleLeaveClick = async (): Promise<void> => {
    onLeaveClick(plex);
  };
  const handleSubscribeClick = async (): Promise<void> => {
    onSubscribeClick(plex);
  };

  if (!canSubscribe(plex.currentUserRelation.state) && !canLeave(plex.currentUserRelation.state)) {
    return (
      <PlexButton
        disabled
        className={classNames(classes.subscribeButton, classes.disabledSubscribeButton)}
        label={'No Action'}
        color={ButtonColor.Gray}
        onClick={handleLeaveClick}
        tooltip={"Owner can't leave"}
      />
    );
  }

  const isSubscribed = plex.currentUserRelation?.role != null;
  const isReader = plex.currentUserRelation?.state === PlexUserRelationState.Subscriber;
  if (isSubscribed) {
    return (
      <PlexButton
        className={classes.subscribeButton}
        label={isReader ? 'Unsubscribe' : 'Leave'}
        color={ButtonColor.Gray}
        disabled={subscribeLoading || leaveLoading}
        onClick={handleLeaveClick}
      />
    );
  }
  return (
    <PlexButton
      className={classes.subscribeButton}
      label={'Subscribe'}
      color={ButtonColor.Primary}
      disabled={subscribeLoading || leaveLoading}
      onClick={handleSubscribeClick}
    />
  );
});

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    subscribeButton: {
      margin: spacings.xlarge,
      height: 52,
    },
    disabledSubscribeButton: {
      width: '100%',
    },
  })
);
